import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { endOfDay, mapIds, startOfDay } from '@core/utils/filters-utils';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { CompanyService } from 'app/main/settings/accounts/companies/services/company.service';
import { isEmpty, isEqual } from 'lodash';
import { debounceTime, filter, switchMap, tap } from 'rxjs/operators';
import { sentry } from 'sentry';
import { ReportsService } from '../reports.service';
import { FilterComponent } from './components/filter/filter.component';
import { DialogChooseCompaniesComponent } from './dialogs/dialog-choose-companies/dialog-choose-companies.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { DataTableMapperService } from './services/data-table.mapper.service';
var CompanyComparisonComponent = /** @class */ (function () {
    function CompanyComparisonComponent(router, matDialog, route, reportsService, companyService, authenticationService, dataTableMapperService, fuseProgressBarService, fuseTranslationLoaderService) {
        this.router = router;
        this.matDialog = matDialog;
        this.route = route;
        this.reportsService = reportsService;
        this.companyService = companyService;
        this.authenticationService = authenticationService;
        this.dataTableMapperService = dataTableMapperService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.isLoading = false;
        this.isLoadingAllData = false;
        this.isFilterOn = false;
        this.selectedCompanies = [];
        this.selectedCompaniesWithTableData = [];
        this.autoReloadTime = 2 * 60000;
        this.routeName = this.route.snapshot.routeConfig.path;
        this.shouldShowStars = ['totalAverage'];
        this.shouldDisplayTooltip = ['timeAverageTotal', 'donePercentage', 'notDonePercentage'];
        this.shouldInFormatDurationDays = ['timeAverageWithDeadline'];
        this.shouldInFormatDurationSeconds = ['pending', 'requested', 'onNegotiation', 'scheduled', 'inProgress', 'reported', 'outOfDeadline', 'timeAverageTotal'];
        this.isPercentage = ['notDonePercentage', 'donePercentage', 'acceptedPercentage', 'refusedPercentage', 'inDeadLinePercentage'];
        this.skeletonColumnsQuantityWhenAlreadySomeDataLoaded = [];
        this.skeletonColumnsQuantityWhenNoDataLoaded = [];
        this.skeletonRowsQuantity = [0, 1, 2, 3, 4, 5];
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    CompanyComparisonComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getSavedData().then(function () {
            _this.updateData();
        });
        this.filterSubscription = this.filter.filtersForm.valueChanges
            .pipe(filter(function () { return _this.filter.filtersForm.valid; }), tap(function () { return _this.isLoadingAllData = true; }), tap(function () { return _this.skeletonColumnsQuantityWhenAlreadySomeDataLoaded = Array.from({ length: _this.selectedCompanies.length }, function (_, index) { return index + 1; }); }), debounceTime(1000), tap(function () { return _this.selectedCompaniesWithTableData = []; }), tap(function () {
            var currentWhere = _this.toQuery(_this.filter.filtersForm.value);
            var defaultWhere = _this.toQuery(_this.filter.defaultFilterValues);
            _this.isFilterOn = !isEqual(currentWhere, defaultWhere);
        }), switchMap(function () { return _this.updateAllData(); })).subscribe(function () {
            _this.isLoadingAllData = false;
            _this.setDataToQueryParams(_this.selectedCompanies);
        });
    };
    CompanyComparisonComponent.prototype.ngOnDestroy = function () {
        if (this.filterSubscription) {
            this.filterSubscription.unsubscribe();
        }
        if (this.filter.filtersForm.invalid) {
            return;
        }
        this.setDataOnLocalStorage();
    };
    CompanyComparisonComponent.prototype.openChooseCompaniesDialog = function () {
        var _this = this;
        var chooseCompaniesDialog = this.matDialog.open(DialogChooseCompaniesComponent, {
            panelClass: ['field-dialog-860'],
            data: {
                selectedCompanies: this.selectedCompanies
            }
        });
        chooseCompaniesDialog.afterClosed().subscribe(function (data) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var hasData;
            return tslib_1.__generator(this, function (_a) {
                hasData = data && data.data;
                if (!hasData) {
                    return [2 /*return*/];
                }
                this.selectedCompanies = data.data.selectedCompanies;
                this.setDataToQueryParams(this.selectedCompanies);
                this.updateData();
                return [2 /*return*/];
            });
        }); });
    };
    CompanyComparisonComponent.prototype.updateData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenanceDataPromises, _loop_1, this_1, _a, _b, company, shouldPreserveSelectedCompanies, shouldRemoveUnselectedCompanies, _c, _d, _e, _f;
            var e_1, _g, _h;
            return tslib_1.__generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        maintenanceDataPromises = [];
                        this.isLoading = true;
                        this.fuseProgressBarService.show();
                        _loop_1 = function (company) {
                            var companyAlreadySelected = !!(this_1.selectedCompaniesWithTableData.filter(function (alreadySelectedCompany) {
                                return alreadySelectedCompany.companyId === company.id;
                            }).length);
                            if (companyAlreadySelected) {
                                return "continue";
                            }
                            maintenanceDataPromises.push(this_1.getCompanyMaintenanceData(company));
                        };
                        this_1 = this;
                        try {
                            for (_a = tslib_1.__values(this.selectedCompanies), _b = _a.next(); !_b.done; _b = _a.next()) {
                                company = _b.value;
                                _loop_1(company);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_g = _a.return)) _g.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.skeletonColumnsQuantityWhenNoDataLoaded = Array.from({ length: this.selectedCompanies.length + 1 }, function (_, index) { return index + 1; });
                        this.skeletonColumnsQuantityWhenAlreadySomeDataLoaded = Array.from({ length: maintenanceDataPromises.length }, function (_, index) { return index + 1; });
                        shouldPreserveSelectedCompanies = this.selectedCompaniesWithTableData.length && maintenanceDataPromises.length;
                        shouldRemoveUnselectedCompanies = !maintenanceDataPromises.length;
                        if (!shouldPreserveSelectedCompanies) return [3 /*break*/, 2];
                        this.selectedCompaniesWithTableData = this.removeUnselectedCompanies(this.selectedCompaniesWithTableData, this.selectedCompanies);
                        _d = (_c = (_h = this.selectedCompaniesWithTableData).push).apply;
                        _e = [_h];
                        return [4 /*yield*/, Promise.all(maintenanceDataPromises)];
                    case 1:
                        _d.apply(_c, _e.concat([tslib_1.__spread.apply(void 0, [_j.sent()])]));
                        return [3 /*break*/, 5];
                    case 2:
                        if (!shouldRemoveUnselectedCompanies) return [3 /*break*/, 3];
                        this.selectedCompaniesWithTableData = this.removeUnselectedCompanies(this.selectedCompaniesWithTableData, this.selectedCompanies);
                        return [3 /*break*/, 5];
                    case 3:
                        _f = this;
                        return [4 /*yield*/, Promise.all(maintenanceDataPromises)];
                    case 4:
                        _f.selectedCompaniesWithTableData = _j.sent();
                        _j.label = 5;
                    case 5:
                        this.selectedCompaniesWithTableDataObjectStructureExample = this.selectedCompaniesWithTableData[0];
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        return [2 /*return*/];
                }
            });
        });
    };
    CompanyComparisonComponent.prototype.removeUnselectedCompanies = function (alreadySelectedCompaniesData, newSelectedCompanies) {
        return alreadySelectedCompaniesData.filter(function (selectedCompanyData) {
            return newSelectedCompanies.some(function (selectedCompany) { return selectedCompany.id === selectedCompanyData.companyId; });
        });
    };
    CompanyComparisonComponent.prototype.updateAllData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenanceDataPromises, _a, _b, company, _c;
            var e_2, _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        maintenanceDataPromises = [];
                        try {
                            for (_a = tslib_1.__values(this.selectedCompanies), _b = _a.next(); !_b.done; _b = _a.next()) {
                                company = _b.value;
                                maintenanceDataPromises.push(this.getCompanyMaintenanceData(company));
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        _c = this;
                        return [4 /*yield*/, Promise.all(maintenanceDataPromises)];
                    case 1:
                        _c.selectedCompaniesWithTableData = _e.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CompanyComparisonComponent.prototype.getCompanyMaintenanceData = function (company) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var where, _a, accountMaintenancesStatus, accountMaintenancesStatusInterval, accountMaintenancesVolumeCount, accountRatingsCount, averageDeadlines, maintenanceData, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        where = this.toQuery(tslib_1.__assign({}, this.filter.filtersForm.value, { companyId: company.id }));
                        return [4 /*yield*/, Promise.all([
                                this.reportsService.accountMaintenancesStatus(where),
                                this.reportsService.accountMaintenancesStatusInterval(where),
                                this.reportsService.accountMaintenancesVolumeCount(where),
                                this.reportsService.getAccountRatingsCount(where),
                                this.reportsService.getAverageDeadlines(where).toPromise(),
                            ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 5]), accountMaintenancesStatus = _a[0], accountMaintenancesStatusInterval = _a[1], accountMaintenancesVolumeCount = _a[2], accountRatingsCount = _a[3], averageDeadlines = _a[4];
                        maintenanceData = {
                            companyId: company.id,
                            name: company.name,
                            avatarUrl: company.avatarUrl,
                            status: accountMaintenancesStatus.status,
                            totalMaintenance: accountMaintenancesStatus.totalMaintenances,
                            statusInterval: accountMaintenancesStatusInterval,
                            volumeCount: accountMaintenancesVolumeCount,
                            ratingsCount: accountRatingsCount,
                            averageDeadlines: averageDeadlines
                        };
                        return [2 /*return*/, this.dataTableMapperService.convertMaintenanceDataToDataTable(maintenanceData)];
                    case 2:
                        err_1 = _b.sent();
                        sentry.captureException(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CompanyComparisonComponent.prototype.toQuery = function (value) {
        return {
            locationGroupId_in: mapIds(value.locationGroups),
            locationId_in: mapIds(value.locations),
            typeId_in: mapIds(value.maintenanceTypes),
            segmentId_in: mapIds(value.segments),
            companyId_in: value.companyId,
            openedAt_gte: startOfDay(value.openedAtGte),
            openedAt_lte: endOfDay(value.openedAtLte),
            scheduledAt_gte: startOfDay(value.scheduledAtGte, 'YYYY-MM-DD'),
            scheduledAt_lte: endOfDay(value.scheduledAtLte, 'YYYY-MM-DD'),
            closedAt_gte: startOfDay(value.closedAtGte),
            closedAt_lte: endOfDay(value.closedAtLte),
        };
    };
    CompanyComparisonComponent.prototype.setDataOnLocalStorage = function () {
        if (this.authenticationService && this.authenticationService.user && this.authenticationService.user.id && this.filter.filtersForm.valid) {
            var userId = this.authenticationService.user.id;
            var hasSavedData = !!(this.selectedCompanies.length || this.isFilterOn);
            var data = hasSavedData ? {
                userId: userId,
                companies: this.selectedCompanies.length ? JSON.stringify(mapIds(this.selectedCompanies)) : null,
                filters: this.isFilterOn ? this.filter.filtersForm.value : null
            } : null;
            localStorage.setItem(this.routeName, JSON.stringify(data));
        }
    };
    CompanyComparisonComponent.prototype.setDataToQueryParams = function (companies) {
        if (this.filter.filtersForm.invalid) {
            return;
        }
        var userId = this.authenticationService.user.id;
        var hasSavedData = !!(this.selectedCompanies.length || this.isFilterOn);
        var navigationQuery = hasSavedData ? {
            queryParams: {
                userId: userId,
                companies: companies.length ? JSON.stringify(mapIds(companies)) : null,
                filters: this.isFilterOn ? JSON.stringify(this.filter.filtersForm.value) : null
            },
            queryParamsHandling: 'merge'
        } : null;
        var url = navigationQuery ? this.router.serializeUrl(this.router.createUrlTree([this.routeName], { queryParams: tslib_1.__assign({}, navigationQuery.queryParams) })) : this.routeName;
        this.router.navigateByUrl(url);
    };
    CompanyComparisonComponent.prototype.formatPercentageData = function (property, tableName, company) {
        var value = company.table[tableName][property];
        if (property === 'inDeadLinePercentage') {
            return (value * 100) + '%';
        }
        return (value % 1 === 0) ? value.toFixed(0) + '%' : value.toFixed(1) + '%';
    };
    CompanyComparisonComponent.prototype.getSavedData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dataFromUrl, dataFromLocalStorage, isUserValidLocalStorage, savedCompaniesLocalStorage, savedFiltersLocalStorage, companies, companyIds, companyIds_1, companyIds_1_1, companyId, _a, _b, e_3_1, isUserValidUrl, companiesFromUrl, filtersFromUrl, company, companiesFromUrl_1, companiesFromUrl_1_1, companyId, _c, _d, e_4_1;
            var e_3, _e, e_4, _f;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        dataFromUrl = this.route.snapshot.queryParams;
                        if (!isEmpty(dataFromUrl)) return [3 /*break*/, 10];
                        dataFromLocalStorage = JSON.parse(localStorage.getItem(this.routeName));
                        isUserValidLocalStorage = dataFromLocalStorage && dataFromLocalStorage.userId === this.authenticationService.user.id;
                        savedCompaniesLocalStorage = dataFromLocalStorage && dataFromLocalStorage.companies;
                        savedFiltersLocalStorage = dataFromLocalStorage && dataFromLocalStorage.filters;
                        if (!isUserValidLocalStorage) {
                            return [2 /*return*/];
                        }
                        if (!savedCompaniesLocalStorage) return [3 /*break*/, 9];
                        companies = [];
                        companyIds = JSON.parse(savedCompaniesLocalStorage);
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 6, 7, 8]);
                        companyIds_1 = tslib_1.__values(companyIds), companyIds_1_1 = companyIds_1.next();
                        _g.label = 2;
                    case 2:
                        if (!!companyIds_1_1.done) return [3 /*break*/, 5];
                        companyId = companyIds_1_1.value;
                        _b = (_a = companies).push;
                        return [4 /*yield*/, this.companyService.getCompanyById(companyId)];
                    case 3:
                        _b.apply(_a, [_g.sent()]);
                        _g.label = 4;
                    case 4:
                        companyIds_1_1 = companyIds_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_3_1 = _g.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (companyIds_1_1 && !companyIds_1_1.done && (_e = companyIds_1.return)) _e.call(companyIds_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        this.selectedCompanies = companies;
                        _g.label = 9;
                    case 9:
                        if (savedFiltersLocalStorage) {
                            this.filter.filtersForm.patchValue(savedFiltersLocalStorage);
                            this.isFilterOn = true;
                        }
                        this.setDataToQueryParams(this.selectedCompanies);
                        return [2 /*return*/];
                    case 10:
                        isUserValidUrl = dataFromUrl.userId === this.authenticationService.user.id;
                        companiesFromUrl = dataFromUrl.companies ? JSON.parse(dataFromUrl.companies) : null;
                        filtersFromUrl = dataFromUrl.filters ? JSON.parse(dataFromUrl.filters) : null;
                        if (!isUserValidUrl) {
                            return [2 /*return*/];
                        }
                        if (!companiesFromUrl) return [3 /*break*/, 19];
                        company = [];
                        _g.label = 11;
                    case 11:
                        _g.trys.push([11, 16, 17, 18]);
                        companiesFromUrl_1 = tslib_1.__values(companiesFromUrl), companiesFromUrl_1_1 = companiesFromUrl_1.next();
                        _g.label = 12;
                    case 12:
                        if (!!companiesFromUrl_1_1.done) return [3 /*break*/, 15];
                        companyId = companiesFromUrl_1_1.value;
                        _d = (_c = company).push;
                        return [4 /*yield*/, this.companyService.getCompanyById(companyId)];
                    case 13:
                        _d.apply(_c, [_g.sent()]);
                        _g.label = 14;
                    case 14:
                        companiesFromUrl_1_1 = companiesFromUrl_1.next();
                        return [3 /*break*/, 12];
                    case 15: return [3 /*break*/, 18];
                    case 16:
                        e_4_1 = _g.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 18];
                    case 17:
                        try {
                            if (companiesFromUrl_1_1 && !companiesFromUrl_1_1.done && (_f = companiesFromUrl_1.return)) _f.call(companiesFromUrl_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 18:
                        this.selectedCompanies = company;
                        _g.label = 19;
                    case 19:
                        if (filtersFromUrl) {
                            this.filter.filtersForm.patchValue(filtersFromUrl);
                            this.isFilterOn = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CompanyComparisonComponent.prototype.removeCompany = function (id) {
        this.selectedCompanies = this.selectedCompanies.filter(function (selectedCompany) { return selectedCompany.id !== id; });
        this.selectedCompaniesWithTableData = this.selectedCompaniesWithTableData.filter(function (selectedCompany) { return selectedCompany.companyId !== id; });
        var queryParams = this.router.routerState.snapshot.root.queryParams;
        var companies = queryParams.companies ? JSON.parse(queryParams.companies) : null;
        if (!companies) {
            return;
        }
        var filteredCompanies = companies.filter(function (company) { return company.id !== id; });
        this.setDataToQueryParams(filteredCompanies);
    };
    CompanyComparisonComponent.prototype.reload = function () {
        this.filter.filtersForm.updateValueAndValidity();
    };
    CompanyComparisonComponent.prototype.autoRefresh = function (event) {
        var _this = this;
        if (event.checked) {
            this.intervalID = setInterval(function () { return _this.reload(); }, this.autoReloadTime);
            return;
        }
        clearInterval(this.intervalID);
    };
    CompanyComparisonComponent.prototype.clearFilters = function () {
        var queryParams = this.router.routerState.snapshot.root.queryParams;
        var shouldClearAllQueryParams = !this.selectedCompanies.length;
        var newQueryParams = {};
        if (shouldClearAllQueryParams) {
            var filters = queryParams.filters, userId = queryParams.userId, restQueryParams = tslib_1.__rest(queryParams, ["filters", "userId"]);
            newQueryParams = restQueryParams;
        }
        else {
            var filters = queryParams.filters, restQueryParams = tslib_1.__rest(queryParams, ["filters"]);
            newQueryParams = restQueryParams;
        }
        var url = this.router.serializeUrl(this.router.createUrlTree([this.routeName], { queryParams: tslib_1.__assign({}, newQueryParams) }));
        this.filter.filtersForm.patchValue(this.filter.defaultFilterValues);
        this.isFilterOn = false;
        this.setDataOnLocalStorage();
        this.router.navigateByUrl(url);
    };
    CompanyComparisonComponent.prototype.clearCompanies = function () {
        var queryParams = this.router.routerState.snapshot.root.queryParams;
        var shouldClearAllQueryParams = !this.isFilterOn;
        var newQueryParams = {};
        if (shouldClearAllQueryParams) {
            var companies = queryParams.companies, userId = queryParams.userId, restQueryParams = tslib_1.__rest(queryParams, ["companies", "userId"]);
            newQueryParams = restQueryParams;
        }
        else {
            var companies = queryParams.companies, restQueryParams = tslib_1.__rest(queryParams, ["companies"]);
            newQueryParams = restQueryParams;
        }
        var url = this.router.serializeUrl(this.router.createUrlTree([this.routeName], { queryParams: tslib_1.__assign({}, newQueryParams) }));
        this.selectedCompanies = [];
        this.selectedCompaniesWithTableData = [];
        this.setDataOnLocalStorage();
        this.router.navigateByUrl(url);
    };
    CompanyComparisonComponent.prototype.getObjectKeys = function (obj) {
        if (!obj) {
            return [];
        }
        return Object.keys(obj);
    };
    return CompanyComparisonComponent;
}());
export { CompanyComparisonComponent };
